import { render, staticRenderFns } from "./GoalContentPageStandards.vue?vue&type=template&id=e60d0efc"
import script from "./GoalContentPageStandards.vue?vue&type=script&lang=js"
export * from "./GoalContentPageStandards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports